import axios from '@sas/nova-core/axios';
import { getLogger } from '@sas/nova-core/logging';

import { RequestParamLimit } from '../../../sonder/rest/paging';
import { CollectionMediaTypeJSON } from '../../../sonder/rest/representations/commons/commons';
import {
  ContextSummaryCollection,
  ContextSummaryMediaTypeJSON,
} from '../../../sonder/rest/representations/compute/context';

import { GO_MAX_INT32 } from '../../util/runtime';

// eslint-disable-next-line @sas/i18n/jsx-to-localize
const logger = getLogger('DataSelection');

export const GetContexts = async (): Promise<[Map<string, string> | undefined, Error?]> => {
  let response;
  try {
    response = await axios({
      method: 'GET',
      url: '/compute/contexts',
      headers: {
        Accept: CollectionMediaTypeJSON,
        'Accept-Item': ContextSummaryMediaTypeJSON,
      },
      params: {
        [RequestParamLimit]: GO_MAX_INT32,
      },
    });
  } catch (error: any) {
    logger.debug(`"GetContexts() error: ${error}`);
    return [undefined, error];
  }

  const collection = response.data as ContextSummaryCollection;
  const ret: Map<string, string> = new Map();
  if (collection.items && collection.items.length > 0) {
    for (const item of collection.items) {
      ret.set(item.id, item.name);
    }
  }
  return [ret, undefined];
};
